import { Colors, Spacing } from "@constants"
import { responsiveSizeWidth } from "@hooks"
import { StyleSheet } from "react-native"

export const prefZoneStyles = (isMobile: boolean) =>
  StyleSheet.create({
    container: {
      width: '100%',
      maxWidth: 400,
    },
    titleText: {
      textAlign: "left",
      marginBottom: Spacing.L,
    },
    fieldLabel: {
      textAlign: "left",
      color: Colors.black,
      marginBottom: Spacing.S,
      fontWeight: "600",
    },
    cardsContainer: {
      flexWrap: "wrap",
    },
    zonesCard: {
      maxWidth: 200,
      height: 40,
      borderRadius: 8,
      borderWidth: 0.5,
      paddingVertical: 5,
      paddingHorizontal: 15,
      marginTop: 10,
      marginRight: 10,
      alignItems: "center",
      justifyContent: "center",
    },
    zonesCardText: {
      color: Colors.foodiBlack,
      fontFamily: "manrope",
      fontSize: 16,
      maxWidth: 200,
    },
    modifyIconContainer: {
      marginTop: 10,
    },
    errorContainer: {
      width: isMobile ? responsiveSizeWidth(340) : 360,
    },
    labelTextIconError: {
      fontSize: 13,
      textAlign: "left",
    },
    labelIconError: {
      marginLeft: isMobile ? 0 : 10,
      alignItems: "center",
    },
  })
